/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Questions_TitleInputs */

const en_platform_questions_title = /** @type {(inputs: Platform_Questions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questions`)
};

const pl_platform_questions_title = /** @type {(inputs: Platform_Questions_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pytania`)
};

/**
* | output |
* | --- |
* | "Questions" |
*
* @param {Platform_Questions_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_questions_title = /** @type {((inputs?: Platform_Questions_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Questions_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_questions_title(inputs)
	return en_platform_questions_title(inputs)
});